import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProviderWorkPlaceState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: ProviderWorkPlaceState = {
  data: [],
  isLoading: false,
  error: null,
};

const providerWorkPlaceSlice = createSlice({
  name: 'providerWorkPlace',
  initialState,
  reducers: {
    setProviderWorkPlaces: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setProviderWorkPlaceLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setProviderWorkPlaceError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setProviderWorkPlaces, setProviderWorkPlaceLoading, setProviderWorkPlaceError } =
  providerWorkPlaceSlice.actions;

export default providerWorkPlaceSlice.reducer;
